<script>
import MovementsEventsTable from '@modules/consolidator/components/movements-events-table/movements-events-table.vue'

export default {
  name: 'AssetTabMovimentacoes',
  components: { MovementsEventsTable },
  props: {
    asset: {
      type: Object,
      required: true,
    },
    sugestoesPorMovimentacao: {
      type: Object,
      default: null,
    },
    client: {
      type: Object,
      default: () => ({}),
    },
    busLeft: {
      type: Object,
      default: null,
    },
    movimentacoes: {
      type: Array,
      default: () => [],
    },
    movements: {
      type: Array,
      default: () => [],
    },
    showAlertFillPu: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCeiAlert() {
      return Boolean(
        this.movimentacoes.length && (this.movimentacoes[0] || {}).ativo_no_cei
      )
    },
  },
}
</script>

<template>
  <div>
    <BaseAlert v-if="showCeiAlert" icon="warning" icon-color="warning" class="my-2">
      <span class="text-normal">
        Movimentações atualizadas junto ao CEI, histórico de 1 ano e meio de
        horizonte passado. Caso tenham mais movimentações antes desse período,
        adicione novos aportes/resgates.
      </span>
    </BaseAlert>
    <BaseAlert
      v-if="showAlertFillPu"
      icon="warning"
      icon-color="warning"
      class="my-2"
    >
      <span class="text-normal">
        Você possui movimentações sem informação de preço unitário e
        quantidade, para conseguir calcular a rentabilidade é necessário
        preenchê-las.
      </span>
    </BaseAlert>
    <MovementsEventsTable
      :sugestoes-por-movimentacao="sugestoesPorMovimentacao"
      @revisar-sugestoes="$emit('revisar-sugestoes', $event)"
      mode="movements"
      hide-title
      :bus="busLeft"
      :client="client"
      :asset="asset"
      :movement-items="movements"
      :show-alert-fill-pu="showAlertFillPu"
      :id-asset-alert-fill-pu="asset.id"
      @remove-movimentacao="$emit('remove-movimentacao', $event)"
      @open-movimentacoes="$emit('open-movimentacoes', $event)"
    />
  </div>
</template>
